import { createAction, createSlice } from "@reduxjs/toolkit";

const updateCourseSlice = createSlice({
  name: "updateCourse",
  initialState: { data: null, processing: false, isSuccess: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      state.isSuccess = true;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    reset(state) {
      state.isSuccess = false;
    },
  },
});

const { name, actions, reducer } = updateCourseSlice;
const updateCourseAction = createAction(name);

export {
  updateCourseAction,
  actions as updateCourseActions,
  reducer as updateCourseReducer,
};
